export const LOGIN_API = "/auth/session";
export const FORGET_PASSWORD_API = "auth/password";
export const RESET_PASSWORD_API = "/auth/reset-password";
export const ADD_INSPECTOR = "/inspector-management";
export const GET_INSPECTOR_DATA = "/inspector-management/list";
export const GET_INSPECTOR_PROJECT_LIST = "inspector-management/projects";
export const ADMIN_PROFILE = "/auth/profile";
export const GET_PROJECT_DATA = "/project-management/list";
export const DELETE_PROJECT = "/project-management";
export const COPY_PROJECT = "/project-management/copy";
export const MERGE_PROJECT = "/project-management/merge";
export const UPLOAD_DOCS = "/master/upload";

export const MASTER_DESCRIPTION = "/master/description";
export const ADD_DESCRIPTION_MASTER = "/master-management/description";
export const MASTER_ENDS = "/master/ends";
export const ADD_ENDS_MASTER = "/master-management/ends";
export const MASTER_INSPECTION_LOC = "/master/inspection-loc";
export const ADD_INSPECTION_LOC_MASTER = "/master-management/inspection-loc";
export const MASTER_MANUFACTURER = "/master/manufacturer";
export const ADD_MANUFACTURER_MASTER = "/master-management/manufacturer";
export const MASTER_SIZE = "/master/size";
export const ADD_SIZE_MASTER = "/master-management/size";
export const MASTER_SURFACE = "/master/surface";
export const ADD_SURFACE_MASTER = "/master-management/surface";
export const MASTER_TYPE = "/master/type";
export const ADD_TYPE_MASTER = "/master-management/type";
export const MASTER_WELDER = "/master/welder";
export const ADD_WELDER_MASTER = "/master-management/welder";

export const ISO_MATERIAL_FORM_LIST = "/form/iso-material/list";
export const ISO_METERIAL_FORM_DETAIL = "/form/iso-material";
export const WELDING_GAS_FORM_LIST = "/form/welding-gas/list";
export const WELDING_GAS_FORM_DETAIL = "/form/welding-gas";
export const WELDING_MACHINE_CALLIBRATION_LIST = "/form/welding-machine/list";
export const WELDING_MACHINE_CALLIBRATION_FORM_DETAIL = "/form/welding-machine";
export const WELDING_WPQ_LIST = "/form/welding-wpq/list";
export const WELDING_WPQ_LIST_FORM_DETAIL = "/form/welding-wpq";
export const ISO_WELD_LOG_FORM_LIST = "/form/iso-weldlog/list";
export const WELD_LOG_FORM_DETAIL = "/form/iso-weldlog";
export const PROJECT_REPORT_LIST = "/form/project-report/list";
export const PROJECT_REPORT_DETAIL = "/form/project-report";
export const PREVIEW_PROJECT_REPORT_PDF = "/form/project-report/preview";
export const DOWNLOAD_PROJECT_REPORT_PDF = "/form/project-report/pdf";
export const DOWNLOAD_ISO_MATERIAL_PDF ="/form/project-report/material_inspection_report";
export const NCR_REPORT_LIST = "/form/ncr-report/list";
export const NCR_REPORT_DETAIL = "/form/ncr-report";
export const PREVIEW_NCR_REPORT_PDF = "/form/ncr-report/preview";
export const DOWNLOAD_NCR_REPORT_PDF = "/form/ncr-report/pdf";
export const DOWNLOAD_ISO_WELD_LOG_PDF = "/form/project-report/iso_weld_log_report";

export const ISO_MATERIAL_SEARCH_FORM = "/form/iso-material/list/global";
export const WELDING_GAS_SEARCH_FORM = "/form/welding-gas/list/global";
export const WELDING_MACHINE_CALLIBRATION_SEARCH_FORM = "/form/welding-machine/list/global";
export const WELDING_WPQ_SEARCH_FORM = "/form/welding-wpq/list/global";
export const ISO_WELD_LOG_SEARCH_FORM = "/form/iso-weldlog/list/global";

export const DASHBOARD = "/master/dashboard";
export const DASHBOARD_PROJECT_STATICS = "/master/dashboard/operator-statics";
export const DASHBOARD_WELD_STATICS = "/master/dashboard/operator-statics/graph";
export const DASHBOARD_FORM_STATUS_STATICS = "/master/dashboard/form-status";
export const DASHBOARD_ERROR_WELD_LOG_STATICS = "/dashboard/";

export const ISO_WELDLOG_SIZE_LIST = "form/iso-weldlog/size";
export const ISO_WELDLOG_MASTER_TYPE_LIST = "/master/ends";
export const MASTER_SERIAL_LIST = "/master/serial";
export const PROJECT_MANAGEMENT_ASSIGN_INSPECTOR_LIST = "/project-management/assign-inspector";

export const ISO_MATERIAL_FORM_LIST_FILTER = "/form/iso-material/filter";
export const WELDING_MACHINE_FORM_LIST_FILTER = "/form/welding-machine/filter";
export const WELD_LOG_FORM_LIST_FILTER = "/form/iso-weldlog/filter";

export const WELDING_WPQ_FORM_LIST_FILTER = "/form/welding-wpq/filter";
export const NCR_REPORT_FORM_LIST_FILTER = "/form/ncr-report/filter";
export const PROJECT_REPORT_FORM_LIST_FILTER = "/form/project-report/filter";
export const WELDING_GAS_FORM_LIST_FILTER = "/form/welding-gas/filter";

export const DASHBOARD_INSPECTION_BREAKDOWN = "/master/dashboard/inspection-breakdown"
export const DASHBOPARD_WELD_LOG_REJECTION_COUNT = "/master/dashboard/weld-log-rejection-count";
export const WELD_COUNT_BY_WELDER = "/master/dashboard/welder-count";
export const WELD_TOTALS_BY_SYSTEM = "master/dashboard/count-by-system";
export const MATERIAL_TOOL_CLASSIFICATION_COUNT = "/master/dashboard/dropdown/classification";
export const MATERIAL_TOOL_LOCATION_COUNT = "/master/dashboard/dropdown/location/";
export const MATERIAL_TOOL_COUNT = "/master/dashboard/count-by-description/";
export const OPERATOR_SUMMARY = "/master/dashboard/operator-summary";
export const WELDER_SUMMARY = "/master/dashboard/welder-summary";
export const DATA_VERFICATION_TABLE = "/dashboard/verification-report"
export const DOWNLOAD_DATA_VERIFICATION_PROJECT = "/dashboard/verification-report/csv";

export const DOWNLOAD_WELDING_MACHINE_CSV = "/form/welding-machine/csv";
export const DOWNLOAD_WELDING_GAS_CSV = "form/welding-gas/csv";
export const DOWNLOAD_ISO_MATERIAL_CSV = "form/iso-material/csv";
export const DOWNLOAD_ISO_WELD_LOG_CSV = "/form/iso-weldlog/csv";
export const DOWNLOAD_WELDING_WPQ_CSV = "/form/welding-wpq/csv";
export const GET_NOTIFICATION = "/master/notification";
export const OTHER_INSPECTION_TYPE = "/master/dashboard/weld-log-rejection-count-by-other";